module.exports = __webpack_public_path__ + "static/media/add.f592a8de.svg";